
export interface LinkedServer {
    id: number
    name: string
    softwareType: string
    createdOn: Date,
    lastConnection: Date | null
    lastConnectionIP: string
    lastFailedLogin: Date | null,
    lastVersion: string,
    linkKey: string,
    linkKeyExpiry: Date | null,
    multiTenant: boolean
    userId: number
    companyId: number
    tenants: LinkedServerTenant[]
}

export interface LinkedServerListDTO {
    id: number
    name: string
    status: LinkedServerStatus
    softwareType: string
    softwareVersion: string
    linkKey: string
    linkKeyExpiry: Date | null
    tenants: LinkedServerTenantDTO[]
}

export interface LinkedServerTenant {
    id: number
    name: string
    accountNumber: number
    tenantId: string
    status: TenantLinkStatus
    features: LinkedFeatures
    deploymentId: number | null
}

export interface LinkedServerTenantDTO {
    id: number
    name: string
    status: TenantLinkStatus
    accountNumber: number
    deploymentId: number | null
    features: LinkedFeatures
}
export interface AddLinkedServerResponse {
    id: number
    linkKey: string
    linkExpiry: Date
}

export interface AddDeploymentFromTenantResponse {
    id: number;
    accountNumber: number;
}

export enum LinkedServerStatus {
    PendingLink,
    Expired,
    Offline,
    Online
}

export enum TenantLinkStatus {
    New,
    AlreadyMapped,
    WrongCompany,
    Mapped
}

export enum LinkedFeatures {
    OnlineLicensing = 1,
    PushNotifications = 2,
    Kaba = 4,
    OnlineBackups = 8
}